<template>
  <v-dialog @click:outside="$emit('closeDialog',true)" v-model="dialog" max-width="600px">
    <v-card>
      <v-toolbar flat elevation="1">
        <v-spacer></v-spacer>
        <v-toolbar-title class="primary--text">Reschedule Session</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <!-- <div class="approve-grid-header mt-4">
          <div class="pr-2 flex-grow-1">
            <span class="py-1">Class</span>
            <v-text-field placeholder="Class" value="7th" full-width solo></v-text-field>
          </div>
          <div class="pr-2">
            <span class="py-1">Subject</span>
            <v-text-field placeholder="Subject" value="Math" full-width solo></v-text-field>
          </div>
        </div> -->
        <v-row>
          <v-col>
            <span class="py-1">Session</span>
            <v-select v-model="data.selected_session" :items="sessions" solo item-value="group_session_id" item-text="group_session_id">
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.group_session_id }}: {{ data.item.group_name }} <i>({{data.item.session_date}} - {{ data.item.session_start_time }})</i>
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.group_session_id }}: {{ data.item.group_name }} <i>({{data.item.session_date}} - {{ data.item.session_start_time }})</i>
              </template>
            </v-select>
          </v-col>

      
        </v-row>


    <v-row>
         <v-col>
            <span class="py-1">Notes</span>
            <v-textarea v-model="data.notes" solo></v-textarea>
          </v-col>
      
        </v-row>

          
      </v-card-text>
      <v-card-actions class="pl-4 pr-4">
        <v-btn @click="$emit('closeDialog',true)">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="rescheduleSession">Approved</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ApproveForm",
  props: [
    'dialog',
    'sessions',
    'item'
  ],
  methods: {
    rescheduleSession(){
       if(this.data.selected_session.length <= 0){
         alert("Student cannot be rescheduled without a session!");
         return false;
       }
       axios.post(apiRoutes.sessions.reschedule+this.item.group_session_attendance_id,this.data).then(response => {
          // console.log(response)
          this.dialog = false;
          location.reload();

          // this.object = response.data.response
          // this.allstudents = response.data.students
        })
    }
  },
  data() {
    return {
      data : {
        selected_session : ''
      },
      tutors: [
        {
          text: "John Doe",
          value: "john"
        },
        {
          text: "Ahmad Fraz",
          value: "ahmad"
        }
      ],
      selected_class: {
        text: "John Doe",
        value: "john"
      },
      dates: [
        "12-06-2020",
        "13-06-2020",
        "14-06-2020",
        "15-06-2020",
        "16-06-2020"
      ],
      time: [
        "08:00 AM",
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
        "03:00 PM",
        "04:00 PM",
        "05:00 PM"
      ],
      selected_date: "12-06-2020",
      selected_start_class: "02:00 PM",
      selected_end_class: "03:00 PM"
    };
  }
};
</script>

<style lang="scss">
.approve-grid-header {
  display: grid;
  grid-template-columns: 1fr 1fr fit-content(50px);
}
.grid-align-center {
  align-self: center;
}
.tutor-assign-grid {
  display: grid;
  grid-template-columns: 1fr 1fr fit-content(50px);
}

.v-list-item {
  & .tutor-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    &__info {
      display: flex;
      flex-direction: column;
    }

    &__name {
      font: 600 13px/20px Segoe UI;
      color: #172b4d;
    }

    &__time,
    &__days {
      font: 500 10px/16px Segoe UI;
      color: #0e0edff7;
    }

    &__days {
      color: #172b4db3;
    }

    &__rating {
      background: #f2a711;
      border-radius: 5px;
      padding: 2px 5px;
      color: #fff;
      font: 600 9px/12px Segoe UI;
    }
  }
}
</style>